import { Grid, Typography } from '@mui/material';
import * as React from 'react'

const Home = () => {
    return (
        <>       
        <Grid container>
        <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 1, color: '#378dab'}}>
                    About Me
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography textAlign={'justify'}>
                <b>Javad Mokhtari Koushyar</b> is a Ph.D. student and 
                Doctoral Research Assistant of Computer Science at
                 Texas State University which he joined in 2023. 
                 He works as a member of &nbsp;
                 <a rel='noreferrer' target='_blank' href="https://userweb.cs.txstate.edu/~mg65/home.html">Intelligent Security Group</a>
                 &nbsp;
                 which is directed by &nbsp;
                 <a rel='noreferrer' target='_blank' href="https://userweb.cs.txstate.edu/~mg65/home.html">Prof. Mina Guirguis</a>.
                 His research focuses on security, networks, and stochastic control, contributing to Cyber-Physical Systems, Networks, Computing Systems, and Mobile Cloud Computing. 
                </Typography>
            </Grid>
        <Grid container sx={{mt: 3}}>
            <Grid item xs={12}>
                <Typography textAlign={'justify'} variant='body1'>
                My journey started in <b>2010</b> when I was a thirteen-year-old teenager and my brother
                 gave me a book entitled &nbsp;<a target='_blank'  href="https://www.amazon.com/C-Programmers-Paul-J-Deitel/dp/0137001304" rel="noreferrer">Programming in C++” by Harvey and Paul Deitel</a>.
                Soon after reading this book, learning what computers are capable of doing became
                 my hobby as a thirteen years old teenager. 
                 I continued my journey enthusiastically by starting my bachelor study in computer engineering
                 , attending to ACM contest, doing an internship and collaborating with research groups in computer engineering.
                  This led to my decision to dedicate my career to enable computers to do what brings us a better future.
                   Thus, scrutinizing comprehensive coursework and endless research resources of the department
                    along with the diverse and high-tech culture of the city, I choose to pursue a Ph.D. program
                     in Computer Science (CS) at The Texas State University.
                </Typography>
            </Grid>
        </Grid>
    </Grid>        
        </>
    )
};

export default Home;